import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    Modal
} from '@mui/material';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ConstantActions } from '../../../Services/_actions';
import { RoleFormData } from '../../../interfaces/Management.interface.ts';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';

interface CreateRoleFormProps {
    open: boolean;
    mode: boolean;
    onClose: (data: RoleFormData | null) => void;
    data: RoleFormData | any;
}

const CreateRoleForm: React.FC<CreateRoleFormProps> = ({ open, mode, onClose, data }) => {
    const constantActions = ConstantActions();
    const [formData, setFormData] = useState<RoleFormData>({
        name: '',
        organisation: '',
    });
    const [organisationList, setOrganisationList] = useState([]);
    const [validationErrors, setValidationErrors] = useState({
        name: '',
        organisation: ''
    });

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const errors: any = {};

        if (!formData.name.trim()) {
            errors.name = 'Role name is required';
        }

        if (!formData.organisation) {
            errors.organisation = 'Organisation is required';
        }

        setValidationErrors(errors);

        if (Object.keys(errors).length === 0) {
            onClose(formData);
        }
    };

    const fetchOrganisation = async () => {
        let res = await constantActions.getOrganisations();
        setOrganisationList(res || []);
    };

    useEffect(() => {
        fetchOrganisation();
        if (mode && data?.id) {
            setFormData({ ...data });
        }
    }, []);
    useEffect(() => {
        if (organisationList?.length === 1) {
            setFormData({
                ...formData,
                organisation: { ...organisationList[0], label: organisationList[0]?.name },
            });
        };
    }, [organisationList])


    return (
        <Modal open={open} onClose={() => { onClose(null) }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '8px',
                    p: 3,
                    width: 400,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
            >
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {`${mode ? "Update" : "Create"} Role`}
                </Typography>
                {/* <SearchableDropdown
                    label={
                        <Typography component="span">
                            Organization <span style={{ color: 'red' }}>*</span>
                        </Typography>
                    }
                    options={
                        organisationList?.length > 0
                            ? organisationList?.map((org: any) => ({
                                ...org,
                                label: `${org.name} (${org.organisation_id})`,
                                value: org.organisation_id,
                            }))
                            : [{ label: 'No Organization', value: '' }]
                    }
                    value={formData?.organisation || null}
                    onChange={(data) => {
                        setFormData({ ...formData, organisation: data });
                        setValidationErrors({ ...validationErrors, organisation: '' });
                    }}
                    error={!!validationErrors.organisation}
                    errorMessage={validationErrors.organisation}

                    sx={{ mb: 1, mt: 2 }}
                    getOptionDisabled={(option) => option.value === ''}
                    disabled={organisationList?.length===1}

                /> */}
                <OrganisationDropdown
                    label={
                        <Typography component="span">
                            Organization <span style={{ color: 'red' }}>*</span>
                        </Typography>
                    }
                    value={formData?.organisation || null}
                    onChange={(data) => {
                        setFormData({ ...formData, organisation: data });
                        setValidationErrors({ ...validationErrors, organisation: '' });
                    }}
                    error={!!validationErrors.organisation}
                    errorMessage={validationErrors.organisation}
                    disabled={organisationList?.length === 1}
                />

                <TextField
                    label={
                        <Typography component="span">
                            Role Name <span style={{ color: 'red' }}>*</span>
                        </Typography>
                    }
                    fullWidth
                    value={formData?.name || ''}
                    onChange={(e) => {
                        setFormData({ ...formData, name: e.target.value });
                        setValidationErrors({ ...validationErrors, name: '' });
                    }}
                    sx={{ marginBottom: 2 }}
                    margin="dense"
                    variant="outlined"
                    size="small"
                    error={!!validationErrors?.name}
                    helperText={validationErrors?.name}

                />
                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                    <Button variant="outlined" onClick={() => { onClose(null) }} size="small">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={(e: any) => handleSubmit(e)}
                        color="primary"
                        size="small"
                    >
                        {`${mode ? "Update" : "Create"}`}

                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default CreateRoleForm;
